import React from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';

import { EvaluatorDropdownContext } from './table';

import { Modal } from '@material-ui/core';

function EvaluatorDropdown({ params, isFirstEvaluator }) {
  const tableProps = React.useContext(EvaluatorDropdownContext);

  const adminStatus = params.data.adminStatus;

  const isRevaluationRequested = params.data.reEvaluationRequested;

  const getValue = () => {
    if (isFirstEvaluator) {
      if (isRevaluationRequested) {
        return params.data.previousEvaluatorId
          ? params.data.previousEvaluatorId
          : null;
      } else {
        return params.data.evaluatorUserId ? params.data.evaluatorUserId : null;
      }
    } else {
      if (isRevaluationRequested)
        return params.data.evaluatorUserId ? params.data.evaluatorUserId : null;
    }
    return null;
  };

  const isSelectDisabled = (() => {
    if (adminStatus !== 'accepted') return true;

    if (isRevaluationRequested) {
      if (isFirstEvaluator) return true;
      else if (params.data.credits) return true;
    } else {
      if (!isFirstEvaluator) return true;
      if (params.data.credits) return true;
    }

    return false;
  })();

  const [selectedUser, setSelectedUser] = React.useState({
    id: null,
    name: null,
  });
  const [openModal, setOpenModal] = React.useState(false);

  return (
    <div className='w-full '>
      <FormControl variant='outlined' className='w-full '>
        <Select
          labelId='demo-simple-select-helper-label'
          id='demo-simple-select-helper'
          disabled={isSelectDisabled}
          value={getValue()}
          onChange={(event, action) => {
            if (!event.target.value) return;

            setSelectedUser({
              id: event.target.value,
              name: action.props.children.join(''),
            });
            setOpenModal(true);
          }}
        >
          <MenuItem value={null}>None</MenuItem>
          {tableProps.evaluatorList.map((val, i) => (
            <MenuItem value={val.userId} key={i} name='xxxd'>
              {val.User.firstName} {val.User.lastName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Modal open={openModal}>
        <div className='relative top-2 md:top-10 m-auto bg-ab-tertiary bg-white rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/2 w-11/12 border-solid border border-gray-600 p-50'>
          <div
            className='absolute right-2 top-2 cursor-pointer'
            onClick={() => {
              setOpenModal(false);
            }}
          >
            X
          </div>

          <h2 className='font-bold text-center'>
            Are you sure, you want to assign this to {selectedUser?.name}?
          </h2>

          <hr />

          <h4 className='mt-2'>Details...</h4>

          <div className='flex justify-end'>
            <button
              className='bg-red-c3 p-1 px-2 rounded-md text-white'
              onClick={() => {
                tableProps.evaluatorChangeFn(
                  params.data.userId,
                  params.data.projectId,
                  selectedUser.id
                );

                setOpenModal(false);
              }}
            >
              OK
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default EvaluatorDropdown;
